import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { selectRegionValue, selectTabValue } from '../shared/store/region.selector';

@Component({
  selector: 'app-docs-menu',
  templateUrl: './docs-menu.component.html',
  styleUrls: ['./docs-menu.component.css'],
})
export class DocsMenuComponent {
  activeTopic!: string;
  region: string = 'Malaysia';
  navbarlg!: boolean;

  constructor(private router: Router, 
    private store: Store) {
    const loc = window.sessionStorage.getItem('location');

    this.store.pipe(select(selectRegionValue)).subscribe((reg) => {
      if(reg!==this.region){
        this.region = reg;
        this.activeTopic = reg;
        this.routeTo(this.activeTopic); 
        this.region = reg;
      }
    });

    store.pipe(select(selectTabValue)).subscribe((tab) => {
      const nav = document.getElementsByClassName("nav-link") as HTMLCollectionOf<HTMLElement>;
      for (let i = 0; i < nav.length; i++) {
        nav[i].classList.remove('active'); // Replace 'active' with the class you want to remove
      }
      const btn = document.getElementById(tab) as HTMLButtonElement;
      btn?.classList.add('active');
    })

    if(loc){
      this.activeTopic = loc!;
      this.routeTo(this.activeTopic);
      const currentURL = loc!.split('/')[loc.split('/').length-1];
      this.activeTopic = currentURL;
    }
    
  }

  scrollToTop() {
    document
      .getElementById('maincontent')
      ?.scrollIntoView({ block: 'start', behavior: 'smooth'});
  }

  ngOnInit() {
    this.onWindowResize();
    
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    if (window.innerWidth >= 1200) {
      this.navbarlg = false;
    } else {
      this.navbarlg = true;
    }
  }
 

  routeTo(pathTo: string) {
    const nav = document.getElementsByClassName("nav-link") as HTMLCollectionOf<HTMLElement>;
      for (let i = 0; i < nav.length; i++) {
        nav[i].classList.remove('active'); // Replace 'active' with the class you want to remove
      }
    const id = pathTo.split("/").reverse()[0]
    const btn = document.getElementById(id) as HTMLButtonElement;
    btn?.classList.add('active');
    this.activeTopic = pathTo;
    window.sessionStorage.setItem('location', pathTo);
    setTimeout(() => this.router.navigate([pathTo]), 200);
  }
}